export const MODAL_TYPES = {
    LOGIN: "login",
    REGISTER: "register",
    VERIFY: "verify",
    FORGOT_PASSWORD: "forgot-password",
    RESET_PASSWORD: "reset-password",
} as const;

export type ModalType = typeof MODAL_TYPES[keyof typeof MODAL_TYPES] | null;